import { render, staticRenderFns } from "./AboutProfilePage.vue?vue&type=template&id=09eefd71&scoped=true&"
import script from "./AboutProfilePage.vue?vue&type=script&lang=js&"
export * from "./AboutProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./AboutProfilePage.vue?vue&type=style&index=0&id=09eefd71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eefd71",
  null
  
)

export default component.exports